
import { Vue, Component, Prop, Model } from 'vue-property-decorator';

@Component
export default class FormCheckboxNew extends Vue {
  @Prop({ type: String, default: '' }) readonly label!: string;
  @Model('input', { type: Boolean }) readonly value!: boolean;

  updateValue(event: Event): void {
    const target = event.target as HTMLInputElement;
    this.$emit('input', target.checked);
  }
}
